import Home from "./Home.vue";
import { createApp } from "vue";
import { definePreset } from '@primevue/themes';
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";

const stonePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{stone.50}',
            100: '{stone.100}',
            200: '{stone.200}',
            300: '{stone.300}',
            400: '{stone.400}',
            500: '{stone.500}',
            600: '{stone.600}',
            700: '{stone.700}',
            800: '{stone.800}',
            900: '{stone.900}',
            950: '{stone.950}'
        }
    },
    components: {
    }
});

class CheckoutLoginPage {
    constructor(body) {
        this.body = body;
        this.$wrapper = this.body;
        this.make_body();
    }
    make_body() {
        if (this.$wrapper.get(0).__vue_app__) {
            this.$wrapper.get(0).__vue_app__.unmount();
        }

        const app = createApp(Home, {});

        app.use(PrimeVue, {
            theme: {
                preset: stonePreset,
                options: {
                    prefix: "pv",
                    darkModeSelector: false,
                    cssLayer: false
                }
            }
        });

        this.$component = app.mount(this.$wrapper.get(0));
    }
}

frappe.provide("soma");
soma.CheckoutLoginPage = CheckoutLoginPage;
export default CheckoutLoginPage;